import { Phone, User, Star, ShieldAlert } from 'lucide-react';

const EmergencyContactsTab = ({ customer }) => {
  const contacts = Array.isArray(customer?.emergencyContacts) ? customer.emergencyContacts : [];

  return (
    <>
      {/* Emergency Contacts */}
      <div className='bg-card border border-border rounded-lg p-6'>
        <div className='flex items-center justify-between mb-4'>
          <h2 className='text-lg font-semibold flex items-center'>
            <ShieldAlert className='mr-2' size={20} />
            Emergency Contacts
          </h2>
          <span className='text-xs text-muted-foreground'>
            {contacts.length} {contacts.length === 1 ? 'contact' : 'contacts'}
          </span>
        </div>

        {contacts.length === 0 ? (
          <p className='text-sm text-muted-foreground'>No emergency contacts added.</p>
        ) : (
          <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
            {contacts.map((contact, index) => (
              <div
                key={contact._id || index}
                className={`rounded-lg border p-4 relative ${
                  contact.isPrimary
                    ? 'border-primary/40 bg-primary/5'
                    : 'border-border bg-muted/30'
                }`}
              >
                {contact.isPrimary && (
                  <span className='absolute top-3 right-3 flex items-center text-[11px] font-medium text-primary'>
                    <Star size={12} className='mr-1 fill-primary text-primary' />
                    Primary
                  </span>
                )}

                <div className='flex items-center mb-3'>
                  <div className='w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center mr-3'>
                    <User size={16} className='text-primary' />
                  </div>
                  <div>
                    <p className='text-sm font-medium'>{contact.name || 'N/A'}</p>
                    <p className='text-xs text-muted-foreground capitalize'>
                      {contact.relationship || 'Relationship not specified'}
                    </p>
                  </div>
                </div>

                <div className='flex items-center text-sm'>
                  <Phone size={14} className='mr-2 text-muted-foreground' />
                  <p className='font-medium'>
                    {contact.countryCode || '+91'} {contact.phoneNumber || 'N/A'}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default EmergencyContactsTab;